// Border tokens, aligned with ui/docs/simkura-design.md.
// Existing keys preserved for back-compat; `lg` added for large cards/modals.
export const BORDER_RADIUS = {
  xs:      '4px',    // inputs, table cells (was 2px — bumped for consistency)
  sm:      '6px',    // buttons (default), small cards
  md:      '8px',    // cards, dropdowns
  lg:      '12px',   // large cards, modals (NEW)
  xl:      '20px',   // hero / large surfaces
  xxl:     '40px',
  pill:    '9999px', // CTAs, status chips, soft pill tags
  rounded: '100%',   // circles
};

export const BORDER_WIDTH = {
  standard: '1px',
  medium:   '1.43px',
};
